import {
  NBS_API_EMAIL_LOGIN_REQUEST,
  NBS_API_EMAIL_LOGIN_SUCCESS,
  NBS_API_EMAIL_LOGIN_FAILURE
} from '../../constants/actions';
import { deviceId, trackNewProfile } from '../../assets/helpers/utils';
import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiEmailLoginRequest () {
  return { type: NBS_API_EMAIL_LOGIN_REQUEST };
}
function nbsApiEmailLoginSuccess (response) {
  return {
    type: NBS_API_EMAIL_LOGIN_SUCCESS,
    response
  };
}
function nbsApiEmailLoginError (error) {
  return {
    type: NBS_API_EMAIL_LOGIN_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiEmailLogin (data) {
  data.device_id = deviceId();
  if (!data.language && strings.getLanguage()) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiEmailLoginRequest());
    return nbsApi('login', data)
      .then(response => {
        if (data.lp_profile_created === true) {
          trackNewProfile();
        }
        dispatch(nbsApiEmailLoginSuccess(response));
      })
      .catch(error => dispatch(nbsApiEmailLoginError(error)));
  };
}
